export default __webpack_public_path__ + "static/media/letsikringveddoed.217bc38e.jpg";